export default __webpack_public_path__ + "static/media/expocebu-1.8e8fb75e.jpg";